export const FAQ_DATA = [
  {
    title: '1. About the App',
    faqs: [
      {
        title: 'What does the app do?',
        description:
          'The app helps you identify your strengths, weaknesses, values, motivations, and goals to enhance your personal and professional growth.',
      },
      {
        title: 'Who is the app for?',
        description:
          'It’s for employees of all levels seeking clarity and growth, and for managers aiming to improve communication and collaboration.',
      },
      {
        title: 'How does the app work?',
        description:
          'Through self-assessments, DISC profiling, and insights, the app provides tools for self-discovery and enables managers to understand and support their team members effectively.',
      },
    ],
  },
  {
    title: '2. Features and Functionality',
    faqs: [
      {
        title: 'What tools does the app provide?',
        description:
          'It offers self-assessments, DISC profiling, goal tracking, and shared insights to improve communication and teamwork.',
      },
      {
        title: 'Can I set personal and work-related goals?',
        description:
          'Yes! You can set and track both personal and professional goals, sharing work-related goals selectively with your manager.',
      },
      {
        title: 'What is DISC profiling, and how does it help?',
        description:
          'DISC profiling identifies your communication style, helping your manager understand how to best collaborate with you and avoid common miscommunication pitfalls.',
      },
    ],
  },
  {
    title: '3. Privacy and Sharing',
    faqs: [
      {
        title: 'Will my manager see all my data?',
        description:
          'No, your manager only sees the insights you choose to share, such as work-related strengths, goals, and communication preferences. You’ll see that the ‘personal’ responses do not include a checkbox and thus aren’t shared.',
      },
      {
        title: 'Can I control what my manager sees?',
        description:
          'Yes, you have full control over what information is shared with your manager through the app’s privacy settings, done via selecting the relevant ‘work / career’ checkbox.',
      },
      {
        title: 'Is my personal information secure?',
        description:
          'Absolutely. All data is secure, and the only way for someone else to see your responses is if you select the checkbox for that ‘work / career’ response. All ‘personal’ responses remain private to you.',
      },
    ],
  },
  {
    title: '4. Getting Started',
    faqs: [
      {
        title: 'How do I start using the app?',
        description:
          'Your organisation provides access. Once you log in, complete the initial activities and self-assessments to get started and explore the app’s features.',
      },
      {
        title: 'How much time does it take to set up?',
        description:
          'That depends on the user and how much time you take to complete the initial assessments. You can then use the app for as little as 5–10 minutes daily/weekly or explore it more deeply at your pace.',
      },
      {
        title: 'Do I need experience with self-assessment tools?',
        description:
          'Not at all! The app is designed to be user-friendly for both beginners and experienced self-assessors.',
      },
    ],
  },
  {
    title: '5. Costs and Subscriptions',
    faqs: [
      {
        title: 'Do I need to pay for the app?',
        description:
          'No, your organisation covers the cost, providing you full access at no expense to you.',
      },
      {
        title: 'Does my organisation benefit from my subscription?',
        description:
          'Yes, managers receive tailored insights to improve communication and foster a more supportive work environment, based on the information you choose to share.',
      },
    ],
  },
  {
    title: '6. Support and Accessibility',
    faqs: [
      {
        title: 'What if I need help using the app?',
        description:
          'We provide in-app support, FAQs, and a dedicated customer service team to assist you.',
      },
      {
        title: 'Is the app accessible on all devices?',
        description:
          'Yes, the app works on iOS, Android, and web platforms, so you can use it anytime, anywhere.',
      },
      {
        title: 'Can I use the app offline?',
        description:
          'Some features are available offline, but others require an internet connection for syncing and updates.',
      },
    ],
  },
  {
    title: '7. Outcomes and Benefits',
    faqs: [
      {
        title: 'How will the app help me professionally?',
        description:
          'It enhances your self-awareness, supports goal setting, and improves communication between you and your manager. As mentioned above, they only see what ‘work / career’ responses you’ve selected via the checkbox.',
      },
      {
        title: 'How does it benefit my manager?',
        description:
          'Your manager gains insights into your communication style and work-related goals, enabling better collaboration and understanding. As mentioned, they only see what you’ve selected to ‘make visible’.',
      },
    ],
  },
  {
    title: '8. Personalisation and Customisation',
    faqs: [
      {
        title: 'Can the app adapt to my specific needs?',
        description:
          'Yes, it tailors recommendations and tools to your inputs, ensuring a personalised experience.',
      },
      {
        title: 'Can I update my goals or DISC profile later?',
        description:
          'Absolutely! You can revise your inputs anytime to reflect your current professional needs and aspirations.',
      },
      {
        title: 'Does the app provide reminders for work-related goals?',
        description:
          'Yes, you can set reminders and notifications to help you stay on track with your professional objectives.',
      },
      {
        title: 'Can I focus only on work-related features?',
        description:
          'Yes, you can use the app exclusively for professional purposes or explore its personal growth tools as well.',
      },
    ],
  },
  {
    title: '9. Integration and Compatibility',
    faqs: [
      {
        title: 'Can the app sync with my work calendar?',
        description:
          'We’re working on a number of integrations, including calendar syncing, while there is a ‘reminder’ style functionality available in the platform.',
      },
      {
        title: 'Does the app work with other workplace tools?',
        description:
          'We’re working on integrations with popular tools to enhance workplace productivity.',
      },
      {
        title: 'Can I export work-related progress?',
        description:
          'No, you’re unable to export, however you can use the share functionality.',
      },
      {
        title: 'Does the app integrate with HR platforms?',
        description:
          "In some cases, it can sync insights with an organisation's existing HR platforms and tools for seamless professional development tracking. This is done in consultation with each organisation.",
      },
    ],
  },
  {
    title: '10. Community and Collaboration',
    faqs: [
      {
        title: 'Can I connect with colleagues through the app?',
        description:
          'We are exploring team-based features to enable collaboration and shared goal-setting.',
      },
      {
        title: 'Can my manager use this app to give feedback?',
        description:
          'Yes, the app facilitates constructive feedback through shared insights and tailored communication strategies.',
      },
    ],
  },
  {
    title: '11. Scientific Basis and Effectiveness',
    faqs: [
      {
        title: 'Is the app scientifically validated?',
        description:
          'Yes, it incorporates proven frameworks like DISC profiling and evidence-based self-development practices.',
      },
      {
        title: 'Has the app been tested for effectiveness?',
        description:
          'The app is backed by user testing and feedback to continually refine and improve its impact on personal growth.',
      },
      {
        title: 'Does the app ensure meaningful professional growth?',
        description:
          'Yes, it provides actionable insights and tools to help you grow within your role and beyond.',
      },
      {
        title: 'Can this app replace professional therapy or coaching?',
        description:
          'No, while it provides valuable self-help tools, it is not a replacement for professional therapy or coaching.',
      },
    ],
  },
  {
    title: '12. Gamification and Motivation',
    faqs: [
      {
        title: 'How does the app keep me motivated?',
        description:
          'It includes a range of activities, achievements, progress tracking, and motivational prompts to sustain your focus and engagement.',
      },
      {
        title: 'Are there team challenges or activities?',
        description:
          'We’re working on features to include team-based challenges and professional development exercises.',
      },
    ],
  },
  {
    title: '13. Data and Progress Tracking',
    faqs: [
      {
        title: 'Can I track only work-related progress?',
        description:
          'Yes, the app lets you focus on professional goals while keeping personal data separate.',
      },
      {
        title: 'Can I reset my work-related data?',
        description:
          'Yes, you can reset shared work-related insights or restart, refresh anytime.',
      },
    ],
  },
  {
    title: '14. Collaboration with Managers',
    faqs: [
      {
        title: 'How does the app improve my relationship with my manager?',
        description:
          'By sharing tailored insights, the app fosters better communication and understanding, enhancing your professional relationship.',
      },
      {
        title: 'Can my manager assign goals to me?',
        description:
          'No, the app is for you. You maintain control over what’s inputted and saved into the app.',
      },
    ],
  },
  {
    title: '15. Technical Support and Updates',
    faqs: [
      {
        title: 'Will my app updates be managed by my organisation?',
        description:
          'Updates are automatic and included in your organisation’s subscription.',
      },
      {
        title: 'Can I suggest new features for workplace use?',
        description:
          'Yes, we welcome feedback to improve professional-focused features.',
      },
    ],
  },
  {
    title: '16. Transitioning Accounts When Leaving the Organisation',
    faqs: [
      {
        title: 'What happens to my account if I leave the organisation?',
        description:
          'When you leave, your account will transition to a personal account. You retain access to your data, and it’s no longer linked to the organisation or visible to anyone else (i.e. your manager).',
      },
      {
        title:
          'Why do I need to provide a secondary email during registration?',
        description:
          'Your secondary email ensures you can access your account after leaving the organisation, enabling a smooth transition to a personal account.',
      },
      {
        title:
          'Will my organisation still have access to my data after I leave?',
        description:
          'No, once your access to the organisation’s subscription / account and their subscription is removed, your data is no longer accessible to the organisation or its admins.',
      },
      {
        title: 'Do I need to pay for the app after leaving the organisation?',
        description:
          'No, after leaving, you’ll be transferred to an individual subscription where you can continue to access all of the features.',
      },
      {
        title: 'How is the app free for individuals?',
        description:
          'We allow partners (advertisers) to periodically promote their relevant messages to you. This ensures the app remains free. Importantly, you will only receive relevant messages from them.',
      },
      {
        title: 'Can I cancel / delete my account anytime?',
        description:
          'Yes, you can delete your account anytime through your account settings once it has been transitioned away from your employer.',
      },
      {
        title: 'How do I know if my account has been successfully transferred?',
        description:
          'You’ll receive an email confirmation to your secondary email once your account is transitioned to a personal account.',
      },
      {
        title: 'Will I lose any of my personal data during the transition?',
        description:
          'No, all your data, including personal goals and progress, will remain intact when your account transitions.',
      },
      {
        title: 'Can I still use work-related insights after leaving?',
        description: 'Yes, any insights you generated remain in your account.',
      },
      {
        title: 'How do I update my personal information after transitioning?',
        description:
          'You can log into your personal account and update your email, preferences, or subscription details anytime.',
      },
      {
        title: 'What if I don’t want to keep using the app after leaving?',
        description:
          'You can choose to deactivate or delete your personal account at any time through your account settings.',
      },
      {
        title: 'Can I rejoin under a new organisation’s account later?',
        description:
          'Yes, if your new organisation uses the app, your personal account can be linked to their subscription for workplace use, retaining your personal data privately.',
      },
    ],
  },
];

export const FAQ_CONFIG = {
  INPUT: {
    textareaProps: {
      placeholder: 'Type something here...',
      type: 'textarea',
      rows: 6,
    },
  },
};
